export enum PublicPredefinedCardsActionTypes {
  FETCHING_PREDEFINED_CARDS = 'set-cards/FETCHING_PREDEFINED_CARDS',
  PREDEFINED_CARDS_RECEIVED = 'set-cards/PREDEFINED_CARDS_RECEIVED',
}
